import { $themeConfig } from '@themeConfig'

const navbar = localStorage.getItem('app-navbar-config')
const footer = localStorage.getItem('app-footer-config')

export default {
  namespaced: true,
  state: {
    layout: {
      isRTL: $themeConfig.layout.isRTL,
      skin: localStorage.getItem('app-skin') || $themeConfig.layout.skin,
      routerTransition: localStorage.getItem('app-router') || $themeConfig.layout.routerTransition,
      type: localStorage.getItem('app-layout-type') || $themeConfig.layout.type,
      contentWidth: localStorage.getItem('app-content-width') || $themeConfig.layout.contentWidth,
      menu: {
        hidden: (JSON.parse(localStorage.getItem('app-menu-hidden')) === true) || $themeConfig.layout.menu.hidden,
      },
      navbar: {
        type: navbar ? JSON.parse(navbar).type : $themeConfig.layout.navbar.type,
        backgroundColor: navbar ? JSON.parse(navbar).backgroundColor : $themeConfig.layout.navbar.backgroundColor,
      },
      footer: {
        type: footer ? JSON.parse(footer).type : $themeConfig.layout.footer.type,
      },
    },
  },
  getters: {},
  mutations: {
    TOGGLE_RTL(state) {
      state.layout.isRTL = !state.layout.isRTL
      document.documentElement.setAttribute('dir', state.layout.isRTL ? 'rtl' : 'ltr')
    },
    UPDATE_SKIN(state, skin) {
      state.layout.skin = skin

      // Update value in localStorage
      localStorage.setItem('app-skin', skin)

      // Update DOM for dark-layout
      if (skin === 'dark') document.body.classList.add('dark-layout')
      else if (document.body.className.match('dark-layout')) document.body.classList.remove('dark-layout')
    },
    UPDATE_ROUTER_TRANSITION(state, val) {
      state.layout.routerTransition = val
      localStorage.setItem('app-router', val)
    },
    UPDATE_LAYOUT_TYPE(state, val) {
      state.layout.type = val
      localStorage.setItem('app-layout-type', val)
    },
    UPDATE_CONTENT_WIDTH(state, val) {
      state.layout.contentWidth = val
      localStorage.setItem('app-content-width', val)
    },
    UPDATE_NAV_MENU_HIDDEN(state, val) {
      state.layout.menu.hidden = val
      localStorage.setItem('app-menu-hidden', val)
    },
    UPDATE_NAVBAR_CONFIG(state, obj) {
      Object.assign(state.layout.navbar, obj)
      localStorage.setItem('app-navbar-config', JSON.stringify(obj))
    },
    UPDATE_FOOTER_CONFIG(state, obj) {
      Object.assign(state.layout.footer, obj)
      localStorage.setItem('app-footer-config', JSON.stringify(obj))
    },
  },
  actions: {},
}
